<template>
  <div />
</template>
<script>
export default {
  mounted() {
    this.$footerMsg.set({
      errMsg: `${this.$t('DIALOG.str05')} ${this.$t('DIALOG.str17')}`,
      errBtn: this.$t('DIALOG.str30'),
      errReload: true,
      priority: 2,
    });
    this.$progressBar.hide();
  },
};
</script>
